export default {
  descricao: {
    value: null,
    required: true,
    state: null
  },
  contas: {
    value: [],
    options: []
  }
}



// WEBPACK FOOTER //
// ./src/views/private/access/notificationgroups/notificationgroup-form.js